"use client";

import { useState } from "react";

import styles from "./styles.module.css";

export const AuthorModal = ({ showModal, setShowModal }) => {
  const [name, setName] = useState("");

  if (!showModal) {
    return null;
  }

  const onSubmit = () => {
    if (name.length) {
      localStorage.setItem("personName", name);
      setShowModal(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onSubmit();
    }
  };

  return (
    <div className={styles.background} onClick={() => setShowModal(false)}>
      <div className={styles.container}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <h2>Introduce yourself</h2>

          <input
            value={name}
            placeholder="Name"
            onChange={(event) => {
              setName(event.target.value);
            }}
            onKeyDown={onKeyDown}
          />

          <div className={styles.actionContainer}>
            <button type="submit" onClick={onSubmit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
